<div class="flex align-center justify-start gap-10 p-10">
  <app-icon name="warning" size="lg" class="material-symbols-outlined icon"></app-icon>
  <h2 mat-dialog-title class="flex-1">You have unsaved changes</h2>
</div>
<mat-dialog-content class="dialog-text">
  Are you sure you want to discard your changes? The updates will be lost.
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="error-btn" mat-dialog-close>Cancel</button>
  <button mat-flat-button class="primary-btn" (click)="continue()" cdkFocusInitial>Discard</button>
</mat-dialog-actions>
